import React from "react";
import { useRouter } from "next/router";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { Hooks, Platform, Util } from "@xt/xtbase";
import VoucherContent from "@/components/Pages/Activity/Voucher";

const { useTranslation } = Hooks;
const { getUrl } = Util;

const HistoryIcon = ({ onClick }) => (
  <button
    type="button"
    aria-label="Voucher History"
    onClick={onClick}
    style={{
      padding: 4,
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "inherit",
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 2.5V17.5H7.84144C6.85178 16.3943 6.25 14.9341 6.25 13.3333C6.25 9.88155 9.04822 7.08333 12.5 7.08333C13.5534 7.08333 14.546 7.34394 15.4167 7.80421V5.83333L12.0833 2.5H3.75ZM17.0833 13.3333C17.0833 15.8646 15.0313 17.9167 12.5 17.9167C9.96869 17.9167 7.91667 15.8646 7.91667 13.3333C7.91667 10.802 9.96869 8.75 12.5 8.75C15.0313 8.75 17.0833 10.802 17.0833 13.3333ZM13.0916 10.9375H11.425V14.2708L13.9509 15.7292L14.7842 14.2858L13.0916 13.3086V10.9375Z"
        fill="white"
      />
    </svg>
  </button>
);

export default function VoucherPage() {
  const router = useRouter();
  const t = useTranslation();

  const handleBack = () => router.back();
  const handleHistory = () => router.push(getUrl("/activity/voucher-history"));

  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      <BackHeader
        title={t("activity.myVouchers") || "My Vouchers"}
        onBack={handleBack}
        right={<HistoryIcon onClick={handleHistory} />}
      />
      <div
        style={{
          paddingTop: Platform.isInApp() ? "env(safe-area-inset-top, 0px)" : "calc(44px + env(safe-area-inset-top, 0px))",
        }}
      >
        <VoucherContent />
      </div>
    </Layout>
  );
}
